function toggleReadMore() {
    const container = document.querySelector('.js_oraSmallContentIntro');

    if (container) {
        container.classList.toggle('oraSmallContentIntro--showMore');
    }
}

function init() {
    const button = document.querySelector('.js_oraSmallContentIntro__readMoreButton');

    if (button) {
        button.addEventListener('click', toggleReadMore);
    }
}

$(document).ready(init);
